"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";

const CompactItemCard = ({
  images,
  title,
  description,
  details,
  linkTo,
}: CompactItem) => {
  return (
    <div className="compact-item-card">
      <div className="compact-item-heading">
        <div className="compact-item-heading-container">
          <span>{title}</span>
        </div>
      </div>
      <div title={title} className="compact-item-image">
      <Link href={`/${linkTo}`} title={title}>
        <Image
          src={images[0].url}
          alt={title}
          height={200}
          width={200}
          quality={100}
          />
          </Link>
      </div>
      {(details || description) && (
        <div className="compact-item-description">
          {details && <p>{details}</p>}
          {description && <p>{description}</p>}
        </div>
      )}
    </div>
  );
};

export default CompactItemCard;
